import React, { useState } from "react";
import {
  Card,
  Button,
  Modal,
  Form,
  Container,
  Row,
  Col,
  ListGroup,
} from "react-bootstrap";
import { motion } from "framer-motion";
import "./admission.css";

const Admission = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    parentName: "",
    childName: "",
    childAge: "",
    email: "",
    phone: "",
    preferredDate: "",
    concerns: "",
    service: "",
  });

  const facilities = [
    {
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS__miEEyjHAo5cgVDrPbovTQRS5NLCptge-Q&s",
      title: "Experienced Teachers",
      description:
        "Dedicated staff trained in special education methodologies.",
    },
    {
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTRhR9qwnS0VSBTTtG_zjG0XejqOCdef9tf1w&s",
      title: "Specialized Curriculum",
      description: "Tailored learning programs that adapt to individual needs.",
    },
    {
      image:
        "https://lh3.googleusercontent.com/proxy/I8UU3aDR7NAiuAWwbXU4-m0XyISnCrrfqX12dLp0R0_1AVT8LjiOmjsNkZxDIqU_VAITFKooMJlDLSG7HrAqk7paP9Wjk750fGmr_tNt6KTRW_uPguQ",
      title: "Structured Environment",
      description:
        "Planned routines promoting learning and social development.",
    },
  ];

  const additionalPrograms = [
    {
      image:
        "https://newzhook.com/wp-content/uploads/2020/01/deepti_school.jpg",
      title: "Montessori School",
      description:
        "Encouraging self-directed learning through hands-on experiences.",
    },
    {
      image: "https://i.ytimg.com/vi/3__dXdPlFwE/maxresdefault.jpg",
      title: "Counseling Services",
      description:
        "Providing emotional and psychological support to students and parents.",
    },
    {
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSIjQm_fxXQ2DBTmkWucdOpVQGMaXg7h78Q9Q&s",
      title: "Vocational Training",
      description: "Equipping students with essential life and career skills.",
    },
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      parent_name: formData.parentName,
      child_name: formData.childName,
      child_age: formData.childAge,
      email: formData.email,
      phone: formData.phone,
      date: formData.preferredDate,
      concerns_questions: formData.concerns,
      service: formData.service,
    };

    try {
      const response = await fetch(
        "https://api.deepticentre.com/deeptischool/add/schedule-visit",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) throw new Error("Failed to submit the form.");

      alert("Your request has been submitted successfully!");

      setFormData({
        parentName: "",
        childName: "",
        childAge: "",
        email: "",
        phone: "",
        preferredDate: "",
        concerns: "",
        service: "",
      });
      setIsFormOpen(false);
    } catch (error) {
      console.error("Error submitting the form:", error);
      alert(
        "There was an issue submitting your request. Please try again later."
      );
    }
  };

  return (
    <div className="school-container">
      {/* Hero Section */}
      <motion.div
        className="hero text-center"
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <h1>Welcome to Deepti Special School and Rehabitation Center</h1>
        <p>Nurturing Every Child's Unique Potential</p>
        <div className="hero-buttons">
          <Button
            className="schedule-visit-btn"
            onClick={() => setIsFormOpen(true)}
          >
            Schedule a Visit
          </Button>
        </div>
      </motion.div>

      {/* Modal for Scheduling a Visit */}
      <Modal show={isFormOpen} onHide={() => setIsFormOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Schedule a School Visit</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            {[
              { label: "Guardian Name", name: "parentName", type: "text" },
              { label: "Student Name", name: "childName", type: "text" },
              { label: "Student Age", name: "childAge", type: "text" },
              { label: "Email", name: "email", type: "email" },
              { label: "Phone Number", name: "phone", type: "text" },
            ].map((field, idx) => (
              <Form.Group className="mb-3" key={idx}>
                <Form.Label>{field.label}</Form.Label>
                <Form.Control
                  type={field.type}
                  name={field.name}
                  value={formData[field.name]}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
            ))}

            <Form.Group className="mb-3">
              <Form.Label>Select a Service</Form.Label>
              <Form.Select
                name="service"
                value={formData.service}
                onChange={handleInputChange}
                required
              >
                <option value="">-- Select a Service --</option>
                <option value="Physiotherapy">Physiotherapy</option>
                <option value="Speech and Language Therapy">
                  Speech and Language Therapy
                </option>
                <option value="Occupational Therapy">
                  Occupational Therapy
                </option>
                <option value="Developmental Therapy">
                  Developmental Therapy
                </option>
                <option value="Hydrotherapy">Hydrotherapy</option>
                <option value="Behavioral Therapy">Behavioral Therapy</option>
                <option value="Yoga Therapy">Yoga Therapy</option>
                <option value="Horticultural Therapy">
                  Horticultural Therapy
                </option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Preferred Date</Form.Label>
              <Form.Control
                type="date"
                name="preferredDate"
                value={formData.preferredDate}
                onChange={handleInputChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Special Concerns or Questions</Form.Label>
              <Form.Control
                as="textarea"
                name="concerns"
                value={formData.concerns}
                onChange={handleInputChange}
              />
            </Form.Group>

            <Modal.Footer>
              <Button className="submit-request-btn w-100" type="submit">
                Submit Request
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
      {/* Admission Criteria & Info */}
      <Container className="admission-info my-5">
        <h2 className="text-center mb-4">Admission Information</h2>
        <Row>
          <Col md={6} className="text-start">
            <h5>Admission Options & Criteria</h5>
            <ListGroup>
              <ListGroup.Item>
                <strong>Special School:</strong> Children with disabilities
                (Autism, CP, Downs Syndrome, ADHD, ID, VI, LD) aged 3–18 with a
                disability certificate.
              </ListGroup.Item>
              <ListGroup.Item>
                <strong>Vocational Training Centre:</strong> Young adults above
                18 years with disabilities.
              </ListGroup.Item>
              <ListGroup.Item>
                <strong>Little Flower Montessori & Pre-School:</strong>{" "}
                Inclusive for children aged 2–6 years.
              </ListGroup.Item>
              <ListGroup.Item>
                <strong>Child Development Centre:</strong> For children aged 0–6
                years.
              </ListGroup.Item>
            </ListGroup>
          </Col>

          <Col md={6}>
            <h5>Required Documents</h5>
            <ListGroup>
              <ListGroup.Item>Birth Certificate</ListGroup.Item>
              <ListGroup.Item>Disability Certificate</ListGroup.Item>
              <ListGroup.Item>2 Passport Size Photos</ListGroup.Item>
              <ListGroup.Item>Aadhaar Card</ListGroup.Item>
              <ListGroup.Item>UDID</ListGroup.Item>
              <ListGroup.Item>Medical Records</ListGroup.Item>
              <ListGroup.Item>
                TC (if transferred from another school)
              </ListGroup.Item>
              <ListGroup.Item>Other Related Documents</ListGroup.Item>
            </ListGroup>
          </Col>
        </Row>

        <Row className="mt-4">
          <div className="p-3 border rounded shadow-sm bg-light">
            <h5>For Enquiries</h5>
            <p>
              <strong>Dr Susan Mathew (Principal):</strong> 9633470888
            </p>
            <p>
              <strong>Mr Richard G Raju (Programme Coordinator):</strong>{" "}
              8590303437
            </p>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default Admission;
